import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {IPagination} from './luci-pagination.model';

@Component({
  selector: 'luci-pagination',
  templateUrl: './luci-pagination.component.html',
  styleUrls: ['./luci-pagination.component.scss']
})
export class LuciPaginationComponent implements OnInit, OnChanges {

  pageInfo: IPagination = {
    startIndex: 0,
    endIndex: 9,
    totalItems : 0,
    totalPages : 0,
    pageSize : 10,
    currentPage : 0,
    startPage : 0,
    endPage : 0,
    pages : []
  };

  @Output() updatePage = new EventEmitter();

  @Input() totalItems = 0;

  @Input() pageSize = 10;

  @Input() position = 'left';

  @Input() reset = false;

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if ( changes.totalItems || changes.pageSize  || this.reset) {
      this.pageInfo.totalItems = changes.totalItems  ? changes.totalItems.currentValue :  this.pageInfo.totalItems;
      this.pageInfo.pageSize = changes.pageSize  ? changes.pageSize.currentValue :  this.pageInfo.pageSize;
      this.updatePageInfo();
    } else if (changes.reset && changes.reset.currentValue) {
      this.pageInfo.pageSize = this.pageSize  ? this.pageSize :  this.pageInfo.pageSize;
      this.pageInfo.totalItems = this.totalItems  ? this.totalItems :  this.pageInfo.totalItems;
      this.updatePageInfo();
    }
  }

  updatePageInfo() {
    this.pageInfo.totalPages = Math.ceil(this.totalItems / this.pageInfo.pageSize);
    this.setPage(1);
  }

  setPage(pageNumber: number) {
    this.pageInfo.currentPage = pageNumber;

    if (this.pageInfo.totalPages <= 5) {
      this.pageInfo.startPage = 1;
      this.pageInfo.endPage = this.pageInfo.totalPages;
    } else {
      if (this.pageInfo.currentPage <= 3) {
        this.pageInfo.startPage = 1;
        this.pageInfo.endPage = 5;
      } else if (this.pageInfo.currentPage + 1 >= this.pageInfo.totalPages) {
        this.pageInfo.startPage = this.pageInfo.totalPages - 4;
        this.pageInfo.endPage = this.pageInfo.totalPages;
      } else {

        if ((this.pageInfo.totalPages - (this.pageInfo.currentPage - 2)) === 5) {
          this.pageInfo.startPage = this.pageInfo.currentPage - 1;
          this.pageInfo.endPage = this.pageInfo.currentPage + 3;
        } else {
          this.pageInfo.startPage = this.pageInfo.currentPage - 2;
          this.pageInfo.endPage = this.pageInfo.currentPage + 2;
        }
      }
    }

    // calculate start and end item indexes
    this.pageInfo.startIndex = (this.pageInfo.currentPage - 1) * this.pageInfo.pageSize;
    this.pageInfo.endIndex = Math.min(this.pageInfo.startIndex + this.pageInfo.pageSize - 1, this.pageInfo.totalItems - 1);

    // create an array of pages to ng-repeat in the pager control
    const pages: any = [];
    Array( this.pageInfo.endPage + 1 ).fill(1).forEach((n, i) =>  {
      if (i >= this.pageInfo.startPage) {
        pages.push(i);
      }
    });
    this.pageInfo.pages = pages;

    // update the parent view
    this.updatePage.emit(this.pageInfo);
  }

}
